// extracted by mini-css-extract-plugin
export var productImage = "_oy-1";
export var viewLink = "_oy-2";
export var wishlistItem = "_oy-0";